import { Navigate, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { PersonalAtendimentosListWrapper } from './meus-atendimentos-list/PersonalAtendimentosList'

const PersonalAtendimentos = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route
        path='lista'
        element={
          <>
            <PageTitle description={t('pagina.meusAtendimentos.descricao')}>
              Meus Atendimentos
            </PageTitle>
            <PersonalAtendimentosListWrapper />
          </>
        }
      />

      <Route index element={<Navigate to='/apps/meus-atendimentos/lista' />} />
    </Routes>
  )
}

export default PersonalAtendimentos
